module.exports = __webpack_public_path__ + "static/media/Book - Passing the Faith onto Loved Ones.216354ab.docx";